module.exports = __webpack_public_path__ + "static/img/15.75820281.gif";